<template>
    <div class="index uk-first-section-xlarge-padding">
        <index-top></index-top>
        <index-bottom :active-filters="activeFilters"></index-bottom>
    </div>
</template>

<script>
  import Top from './IndexTop.vue';
  import Bottom from './IndexBottom.vue';

  export default {
    name: 'Index',
    components: {
      'index-top': Top,
      'index-bottom': Bottom
    },
    data() {
      return {
        activeFilters: {
          department: [],
          locations: [],
        },
        popstate: false,
        queryDepartment: null,
        queryLocation: null,
      }
    },
    computed: {
      // The list of all locations mapped in WD
      allLocations: function(){
        return Object.values(this.$root.source.job_data.locations);
      },
    },
    methods: {
      setFilterDept: function(d){
        this.popstate = false;

        if (this.activeFilters.department[0] === d || d === null) {
          this.activeFilters.department.pop();
        } else {
          this.activeFilters.department = [];
          this.activeFilters.department.push(d);
        }
      },
      setFilterLocations: function(l) {
        this.popstate = false;

        let index = this.activeFilters.locations.indexOf(l);
        if (index > -1) {
          this.activeFilters.locations.splice(index, 1);
        } else {
          this.activeFilters.locations.push(l);
        }
      },
      deleteFilterArg: function(a){
        this.popstate = false;

        this.activeFilters[a[0]].splice(this.activeFilters[a[0]].indexOf(a[1]), 1)
      },
      clearFilters: function(){
        this.popstate = false;

        for (let prop in this.activeFilters) {
          if (this.activeFilters.hasOwnProperty(prop)){
            this.activeFilters[prop].splice(0, this.activeFilters[prop].length)
          }
        }
      },
      viewDept: function(department, count = true){
        this.clearFilters();
        if (count){
          this.setFilterDept(department);
        }
      },
      viewLocation: function(location, count = true){
        this.clearFilters();
        if (count){
          // This resets the location filter
          this.activeFilters.locations = [location];
        }
      },
      getLocationsByCountry: function(c){
        let locations = [];

        // Search for underscores and replace them
        if (c.indexOf('_') !== -1){
          c = c.replace('_', ' ');
        }

        for (let location of this.allLocations){
          if (location.country.toLowerCase() === c.toLowerCase()){
            locations.push(location.id)
          }
        }

        return locations;
      },
      parseQueryToFilterParams: function(popstate = false){
        this.popstate = popstate;

        let query = this.$route.query;
        // If query is empty or it's a popstate event
        if (query.constructor === Object && Object.keys(query).length === 0 && this.popstate){
          this.clearFilters();
        } else {
          // If query has a 'country' parameter, which toggles multiple locations
          if (query.hasOwnProperty('country') && query.country.length) {
            // Create a variable to be able to push extra values manually later
            let locations = this.getLocationsByCountry(query.country);
            this.activeFilters['locations'] = locations;
          } else {
			  // Activate corresponding tabs in the top block
            if (query.hasOwnProperty('department') && query.department) {
				this.queryDepartment = query.department;

			}
            if (query.hasOwnProperty('locations') && query.locations) {
              let locationsArray = query.locations.split(',');
              if (locationsArray.length === 1) {
                this.queryLocation = locationsArray[0];
              } else {
                this.queryLocation = 'multiple';
              }
            }

            // Reassign activeFilters values form query
            for (let prop in this.activeFilters) {
              if (query.hasOwnProperty(prop) && query[prop].length) {
                let filterParam = query[prop].split(',');
                if (prop === 'department') {
                  filterParam = filterParam[0];
                  this.activeFilters[prop] = [];
                  this.activeFilters[prop].push(filterParam);
                } else {
                  this.activeFilters[prop] = filterParam;
                }
              } else {
                this.activeFilters[prop].splice(0, this.activeFilters[prop].length);
              }
            }
          }
        }
      },
    },
    watch: {
      /**
       *  Watch for the active filters object to change and push updates to url parameters
       */
      activeFilters: {
        handler: function(filters){

          if (!this.popstate){

            let query = {};

            for (let [prop, value] of Object.entries(filters)) {

              if (filters.hasOwnProperty(prop) && filters[prop].length){
                query[prop] = value.join(',');
              }

            }

            this.$router.push({path: '/', query: query }).catch(err => {});
          }
        },
        deep: true
      },
    },
    created: function() {
      // Set filters from URL query
      this.parseQueryToFilterParams();

      const $pop_self = this;

      window.onpopstate = function(e){
        let popTimeout = window.setTimeout(
            function(){
                $pop_self.parseQueryToFilterParams(true);
            }, 0
        );
      };
    },
  }
</script>
